module.exports = __webpack_public_path__ + "media/yokattane.26f00bfd.mp3";